"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isActionId = exports.isControlId = exports.isRiskId = exports.getActionId = exports.getControlId = exports.getRiskId = void 0;
function getRiskId(risk) {
    return "risk_" + risk.risk.id;
}
exports.getRiskId = getRiskId;
function getControlId(control) {
    return "control_" + control.control.id;
}
exports.getControlId = getControlId;
function getActionId(action) {
    return "action_" + action.action.id;
}
exports.getActionId = getActionId;
function isRiskId(id) {
    var re = /^(risk_[\d]+)$/;
    return id.match(re) != null;
}
exports.isRiskId = isRiskId;
function isControlId(id) {
    var re = /^(control_[\d]+)$/;
    return id.match(re) != null;
}
exports.isControlId = isControlId;
function isActionId(id) {
    var re = /^(action_[\d]+)$/;
    return id.match(re) != null;
}
exports.isActionId = isActionId;
